import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./utils/apiSlice";
import authReducer from "./utils/authSlice";
import gamificationReducer from "./utils/gamificationSlice";
import languageReducer from "./utils/languageSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    gamification: gamificationReducer,
    language: languageReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
